module.exports = __webpack_public_path__ + "img/pic-2.fd890500.png";